import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { beaconConfig } from "./data";

export default function BeaconPage() {
  return <CityPageTemplate config={beaconConfig} />;
}